import useCustomizableCloset from "@hooks/use-customizable-closet";
import { useOpenDrawer } from "@hooks/use-drawer";
import Image from "@components/core/Image";
import IconSvg from "@components/core/IconSvg";

function DrawerIcon() {
  const currentCloset = useCustomizableCloset();
  const openDrawer = useOpenDrawer();

  const isClosetFull = currentCloset?.ready_to_pack_status?.status;

  return (
    <div className="drawer-container tour-guide-target-step-1" style={{ zIndex: 2 }}>
      <div
        className="position-relative cursor-pointer drawer-icon"
        onClick={openDrawer}
        aria-hidden="true"
      >
        <IconSvg
          name="drawer_icon"
          className="drawer-icon-picture"
        />

        {currentCloset?.state === "ready_to_change" && !isClosetFull && (
          <span className="drawer-icon-counter font-size-xs">
            {currentCloset.closet_items.length}
          </span>
        )}

        {currentCloset?.state === "ready_to_change" && isClosetFull && (
          <span className="drawer-icon-counter">
            <Image
              src="readyToValidate"
              alt="full-icon"
              className="w-100"
            />
          </span>
        )}
      </div>
    </div>
  );
};

export default DrawerIcon;
